<template>
  <div class="base_main bg-contain common-blue-contain configure">
    <div class="breadcrumb-tilte">{{ $t('monitoringCenter') }} > {{ $t('controlEquipment') }}</div>
    <div class="common-table-cnt common-aside-cnt-top">
      <div class="common-aside tree-container">
        <div class="serachLine">
          <div class="tip"></div>
          <el-input :placeholder="$t('organizationName')" clearable v-model="searchOrgName"> </el-input>
        </div>
        <el-tree
          :data="mechanismData"
          :props="defaultProps"
          node-key="id"
          default-expand-all
          :expand-on-click-node="false"
          @node-click="handleNodeClick"
          :current-node-key="defaultId"
          :highlight-current="true"
          :filter-node-method="filterTreeNode"
          ref="dataConfigTree"
        >
          <span class="custom-tree-node" slot-scope="{ node }">
            <template>
              <span>
                <span class="tenant" v-if="node.data.type === 1">{{ node.data.name }}</span>
                <span class="node-txt" v-else>{{ node.data.name }}</span>
              </span>
            </template>
          </span>
        </el-tree>
      </div>
      <div class="common-aside-main" style="right:15px;">
        <div class="main">
          <div class="search search-container ">
            <el-form :inline="true" :model="formInline" class="demo-form-inline">
              <el-form-item :label="$t('mechanism')" :label-width="formLabelWidth" v-show="currentType !== 1">
                <el-select
                  ref="paramOuSelect"
                  v-model="formInline.ouName"
                  style="width:auto"
                  :placeholder="$t('peaseSelect')"
                  :popper-append-to-body="false"
                  @change="changeParamOu"
                  clearable
                  @visible-change="visibleChange"
                >
                  <el-option :value="formInline.ouName" style="height:auto;padding:0px">
                    <el-tree
                      ref="paramOuTree"
                      node-key="id"
                      default-expand-all
                      highlight-current
                      :expand-on-click-node="false"
                      :data="ouList"
                      :props="defaultProps"
                      @node-click="selectParamOu"
                    >
                    </el-tree>
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('nameC')" v-show="currentType !== 1">
                <el-input v-model="formInline.cabinetName" clearable :placeholder="$t('nameC')"></el-input>
              </el-form-item>
              <el-form-item :label="$t('canggeNumber')" v-show="currentType == 1">
                <el-input v-model="formInline.cellIdentifier" clearable :placeholder="$t('canggeNumber')"></el-input>
              </el-form-item>
              <el-form-item :label="$t('belongPerson')" v-show="currentType == 1">
                <el-input v-model="formInline.userBindName" clearable :placeholder="$t('belongPerson')"></el-input>
              </el-form-item>
              <el-form-item :label="$t('chargingState')">
                <el-select v-model="formInline.chargeStatus" clearable :placeholder="$t('peaseSelect')">
                  <el-option
                    v-for="item in status"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="handleSearch">{{ $t('query') }}</el-button>
              </el-form-item>
            </el-form>
          </div>
          <div class="content">
            <el-row type="flex" justify="space-between" class="static">
              <el-col :span="9">
                <span class="title"
                  >{{ $t('smartCell') }}:
                  <i class="number"
                    >{{ staticsInfo.chargingCell ? staticsInfo.chargingCell : 0 }}<i class="symbol">/</i
                    >{{ staticsInfo.totalCell ? staticsInfo.totalCell : 0 }}</i
                  >
                </span>
                <span class="title"
                  >{{ $t('Charging') }}:
                  <i class="number">{{ staticsInfo.chargingNumber ? staticsInfo.chargingNumber : 0 }}</i>
                </span>
                <span class="title"
                  >{{ $t('charged') }}:
                  <i class=" finsh">{{ staticsInfo.chargedNumber ? staticsInfo.chargedNumber : 0 }}</i>
                </span>
                <span class="title"
                  >{{ $t('idleCharging') }}:
                  <i class="idle">{{ staticsInfo.idleNumber ? staticsInfo.idleNumber : 0 }}</i>
                </span>
              </el-col>
              <el-col :span="16" style="text-align: right;">
                <span class="text-title">{{ $t('legend') }}:</span>
                <span class="cabinet-num" v-show="currentType !== 1">
                  <img class="num-icon" src="@/icon/cabinet/ic_3.png" alt="" />
                  <span>{{ $t('chargingCellNumber') }}</span><i class="symbol">/</i>
                  <img class="num-icon" src="@/icon/cabinet/ic_1.png" alt="" /><span>{{ $t('totalCell') }}</span>
                </span>
                <span class="cabinet-num">
                  <img class="num-icon" src="@/icon/cabinet/ic_2.png" alt="" />
                  <span>{{ $t('chargingDeviceNumber') }}</span><i class="symbol">/</i>
                  <img class="num-icon" src="@/icon/cabinet/ic_4.png" alt="" />
                  <span class="finsh">{{ $t('chargedDeviceNumber') }}</span>
                  <i class="symbol">/</i>
                  <img class="num-icon" src="@/icon/cabinet/ic_5.png" alt="" />
                  <span class="idle">{{ $t('cellIdleSocket') }} </span>
                </span>
              </el-col>
            </el-row>
            <div class="cabinets" v-show="currentType !== 1">
              <div class="cabinet-item " v-for="(item, index) in tableData" :key="index" @click="handleInfo(item)">
                <el-row type="flex" justify="space-between" class="cabinet-info">
                  <el-col :span="11">
                    <img class="cabinet-icon" src="@/icon/cabinet/img1.png" alt="" />
                  </el-col>
                  <el-col>
                    <div class="item-title">{{ item.cabinetName }}</div>
                    <div class="item-num">
                      <img class="num-icon" src="@/icon/cabinet/ic_3.png" alt="" />
                      <span>{{ item.chargingCell !== 0 ? item.chargingCell : '-' }}</span>
                      <i class="symbol">/</i>
                      <img class="num-icon" src="@/icon/cabinet/ic_1.png" alt="" />
                      <span>{{ item.totalCell !== 0 ? item.totalCell : '-' }}</span>
                    </div>
                    <div class="item-num">
                      <img class="num-icon" src="@/icon/cabinet/ic_2.png" alt="" />
                      <span>{{ item.chargingNumber !== 0 ? item.chargingNumber : '-' }}</span>
                      <i class="symbol">/</i>
                      <img class="num-icon" src="@/icon/cabinet/ic_4.png" alt="" />
                      <span class="finsh">{{ item.chargedNumber !== 0 ? item.chargedNumber : '-' }}</span>
                      <i class="symbol">/</i>
                      <img class="num-icon" src="@/icon/cabinet/ic_5.png" alt="" />
                      <span class="idle">{{ item.idleNumber !== 0 ? item.idleNumber : '-' }}</span>
                    </div>
                  </el-col>
                </el-row>
              </div>
            </div>
            <div v-if="currentType == 1" class="cabinets">
              <div class="cell-item" v-for="(item, index) in tableData" :key="index" @click="handleRecord(item, index)">
                <div class="state" v-if="item.cellStatus === 1">{{ $t('openP') }}</div>
                <el-row type="flex" justify="space-between" class="cabinet-info">
                  <el-col :span="11" class="cell-icon">
                    <img class="cabinet-icon" src="@/icon/cabinet/img2.png" alt="" />
                    <i>{{ item.identifier }}</i>
                  </el-col>
                  <el-col>
                    <div class="item-title">
                      <el-tooltip
                        class="item"
                        effect="dark"
                        :content="
                          item.userBinds && item.userBinds.length == 1
                            ? item.userBinds[0].userName
                            : item.userBinds && item.userBinds[0] && item.userBinds.length > 1
                            ? item.userBindContent
                            : ''
                        "
                        placement="top"
                      >
                        <i class="name">
                          <i v-if="item.userBinds && item.userBinds[0]">{{ item.userBinds[0].userName }}</i>
                          <i v-if="item.userBinds && item.userBinds.length > 1">
                            {{$t('reach')}} {{ item.userBinds.length - 1 }} {{ $t('people') }}
                          </i>
                        </i>
                      </el-tooltip>
                    </div>
                    <div class="item-num">
                      <img class="num-icon" src="@/icon/cabinet/ic_2.png" alt="" />
                      <span>{{ item.chargingNumber !== 0 ? item.chargingNumber : '-' }}</span>
                      <i class="symbol">/</i>
                      <img class="num-icon" src="@/icon/cabinet/ic_4.png" alt="" />
                      <span class="finsh">{{ item.chargedNumber !== 0 ? item.chargedNumber : '-' }}</span>
                      <i class="symbol">/</i>
                      <img class="num-icon" src="@/icon/cabinet/ic_5.png" alt="" />
                      <span class="idle">{{ item.idleNumber !== 0 ? item.idleNumber : '-' }}</span>
                    </div>
                  </el-col>
                </el-row>
              </div>
            </div>
          </div>
          <el-pagination
            class="pagination"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="formInline.pageNum"
            :page-sizes="selectPageSize"
            :page-size="formInline.pageSize"
            :pager-count="5"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalData"
          ></el-pagination>
          <video style="width: 400px;height: 300px;" ref="videoElement" id="my-video"></video>
          <!-- <video style="width: 400px;height: 300px;" src="rtsp://admin:huawei1997@192.168.0.109:554/Streaming/channels/101"></video> -->
        </div>
      </div>
    </div>
    <el-dialog
      :title="tableTitle"
      :visible.sync="tableVisible"
      class="cellDialog mainContain "
      :append-to-body="true"
      width="820px"
      :close-on-click-modal="false"
    >
      <div class="common-blue-tabs view-info">
        <el-tabs v-model="activeName" type="card" @tab-click="handleTab">
          <el-tab-pane :label="$t('chargingState')" name="chargingState"></el-tab-pane>
          <el-tab-pane :label="$t('openClosingRecord')" name="openClosingRecord"> </el-tab-pane>
          <el-tab-pane :label="$t('belongUser')" name="belongUser"> </el-tab-pane>
        </el-tabs>
      </div>
      <div class="search search-container " v-show="activeName === 'openClosingRecord'">
        <el-form :inline="true" :model="recorsFrom" class="demo-form-inline" style="overflow: auto;">
          <el-form-item :label="$t('operatingUsers')" :label-width="formLabelWidth">
            <el-input v-model="recorsFrom.remoteUserName" clearable :placeholder="$t('operatingUsers')"></el-input>
          </el-form-item>
          <el-form-item :label="$t('operatingDate')" :label-width="formLabelWidth">
            <el-date-picker
              v-model="recorsFrom.logDateTimeBegin"
              :placeholder="$t('startDate')"
              type="date"
              value-format="yyyy-MM-dd"
              popper-class="date-picker-blue-hw"
              :clearable="true"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item :label="$t('TO')">
            <el-date-picker
              v-model="recorsFrom.logDateTimeEnd"
              :placeholder="$t('endDate')"
              type="date"
              value-format="yyyy-MM-dd"
              popper-class="date-picker-blue-hw"
              :clearable="true"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="getCellOperation">{{ $t('query') }}</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div>
        <!-- table 组件 -->
        <Table
          :data="recordData"
          :tableHeight="activeName === 'belongUser' ? 300 : 400"
          :columns="columns"
          :serialNumber="showSerialNumber"
          :currentPage="recorsFrom.pageNum"
          :pageSize="recorsFrom.pageSize"
          @sortChange="handleSort"
        ></Table>
        <el-pagination
          v-if="activeName === 'openClosingRecord'"
          style="margin-top: 10px;"
          @size-change="handleSizeCell"
          @current-change="handleCurrentCell"
          :current-page="recorsFrom.pageNum"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="recorsFrom.pageSize"
          :pager-count="5"
          layout="total, sizes, prev, pager, next, jumper"
          :total="recorstotalData"
        >
        </el-pagination>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  devicecabinetTree,
  devicecabinetFind,
  cabinetStatistics,
  cabinetCellStatistics,
  cabinetCellPage,
  cabinetCellCharge,
  cabinetCellOperation,
} from '@/api/new-device/controlCabinet'
// 引入table组件
import Table from '@/components/table'
export default {
  data() {
    return {
      formInline: {
        pageNum: 1,
        pageSize: 12,
      },
      selectPageSize: [12, 24, 48, 96],
      totalData: 0,
      tableData: [],
      formLabelWidth: '120px',
      // 结构树的数据
      mechanismData: [],
      // 结构树数据值绑定方式
      defaultProps: {
        label: 'name',
        children: 'children',
      },
      // 左边结构树搜索绑定值
      searchOrgName: '',
      // 当前选中机构的数据
      currentTreeKey: [],
      // 作用于默认选择/当前结构树的第一个的id
      defaultId: '',
      status: [
        {
          label: this.$t('idle'),
          value: 0,
        },
        {
          label: this.$t('charging'),
          value: 1,
        },
        {
          label: this.$t('charged'),
          value: 2,
        },
      ],
      // 统计数据
      staticsInfo: {},
      currentType: 0,
      activeName: 'chargingState',
      // 记录弹窗
      tableVisible: false,
      tableTitle: '',
      recordData: [],
      columns: [],
      recorsFrom: {
        pageNum: 1,
        pageSize: 10,
      },
      recorstotalData: 0,
      // 是否显示序号
      showSerialNumber: false,
      currentBindUser: [],
      // 机构树数据
      ouList: [],
      currentNode: null,
    }
  },
  components: { Table },
  watch: {
    // 机构树搜索名字监听
    searchOrgName(val) {
      this.$refs.dataConfigTree.filter(val)
    },
  },
  methods: {
    // 获取仓格充电记录
    getCellCharge() {
      this.showSerialNumber = false
      this.columns = [
        {
          attrName: 'socketIdentifier',
          label: this.$t('socketNumber'),
          sort: 'socketIdentifier',
          align: 'center',
        },
        {
          attrName: 'startChargingTime',
          label: this.$t('startChargingTime'),
          sort: 'startChargingTime',
          align: 'center',
        },
        {
          attrName: 'chargedDuration',
          label: this.$t('chargedCuration'),
          sort: 'chargedDuration',
          align: 'right',
        },
        {
          attrName: 'socketStatus',
          label: this.$t('chargingState'),
          sort: 'socketStatus',
          align: 'center',
        },
      ]
      cabinetCellCharge(this.recorsFrom).then(res => {
        if (res.state === 0) {
          res.data.map(item => {
            if (item.socketStatus === 1) {
              item.socketStatus = this.$t('charging')
            } else if (item.socketStatus === 2) {
              item.socketStatus =  this.$t('charged')
            } else if (item.socketStatus === 3) {
              item.socketStatus = this.$t('damage')
            } else {
              item.socketStatus =  this.$t('idle')
              item.startChargingTime = '-'
              item.chargedDuration = '-'
            }
          })
          this.recordData = res.data
        }
      })
    },
    handleSizeCell(val) {
      this.recorsFrom.pageSize = val
      this.getCellOperation()
    },
    handleCurrentCell(val) {
      this.recorsFrom.pageNum = val
      this.getCellOperation()
    },
    // 获取仓格操作记录
    getCellOperation() {
      this.showSerialNumber = true
      this.columns = [
        {
          attrName: 'remoteUserName',
          label: this.$t('operatingUsers'),
          sort: 'remoteUserName',
        },
        {
          attrName: 'type',
          label: this.$t('operationType'),
          sort: 'operationType',
        },
        {
          attrName: 'logTimestamp',
          label: this.$t('operatingDate'),
          sort: 'logTimestamp',
          align: 'center',
        },
      ]
      cabinetCellOperation(this.recorsFrom).then(res => {
        if (res.state === 0) {
          res.data.list.map(item => {
            if (item.operationType === 1) {
              item.type = this.$t('openWarehouse')
            } else {
              item.type = this.$t('closingWarehouse')
            }
          })
          this.recordData = res.data.list
          this.recorstotalData = res.data.total
        }
      })
    },
    // 排序
    handleSort(data) {
      this.recorsFrom.sortColName = !data.order ? null : data.column.sortable
      this.recorsFrom.useAsc = data.order === 'descending' ? 0 : 1
      if (this.activeName === 'chargingState') {
        this.getCellCharge()
      } else if (this.activeName === 'openClosingRecord') {
        this.getCellOperation()
      }
    },
    handleTab(val) {
      this.recorsFrom.pageNum = 1
      this.recorsFrom.pageSize = 10
      if (val.name === 'chargingState') {
        this.getCellCharge()
      } else if (val.name === 'openClosingRecord') {
        this.getCellOperation()
      } else {
        this.columns = [
          {
            attrName: 'userName',
            label: this.$t('belongUser'),
            sort: 'userName',
            align: 'center',
          },
        ]
        this.recordData = this.currentBindUser
        this.showSerialNumber = true
      }
    },

    // 点击仓格查看充电记录
    handleRecord(val, idx) {
      this.recorsFrom = {
        pageNum: 1,
        pageSize: 10,
      }
      this.recorsFrom.cellId = val.id
      this.currentBindUser = val.userBinds

      this.getCellCharge()
      this.activeName = 'chargingState'
      this.tableVisible = true
      let name = this.currentTreeKey.cabinetName ? this.currentTreeKey.cabinetName : this.currentTreeKey.name
      this.tableTitle = name + '-' + val.identifier + this.$t('numberCompartment')
    },
    // 点击柜查看仓格详情
    handleInfo(item) {
      this.formInline.id = item.id
      this.currentTreeKey = item
      this.currentType = 1
      this.formInline.pageNum = 1
      this.formInline.pageSize = 30
      this.selectPageSize = [30, 60, 90, 120]
      this.getCellStatic()
      this.getCells()
    },
    // 获取柜=》仓格统计
    getCellStatic() {
      cabinetCellStatistics(this.formInline).then(res => {
        if (res.state === 0) {
          this.staticsInfo = res.data
        }
      })
    },
    // 获取仓格列表
    getCells() {
      cabinetCellPage(this.formInline).then(res => {
        if (res.state === 0) {
          res.data.list.map(item => {
            if (item.userBinds && item.userBinds.length > 1) {
              item.userBindContent = item.userBinds[0].userName + this.$t('reach') + (item.userBinds.length - 1) + this.$t('people')
            }
          })
          this.tableData = res.data.list
          this.totalData = res.data.total
        }
      })
    },
    // 节点过滤
    filterTreeNode(value, data) {
      if (!value) return true
      return data.name.indexOf(value) !== -1
    },

    handleSizeChange(val) {
      this.formInline.pageSize = val
      this.handleSearch()
    },
    handleCurrentChange(val) {
      this.formInline.pageNum = val
      this.handleSearch()
    },
    // 判断类型执行请求
    handleSearch() {
      if (this.currentType === 1) {
        this.getCells()
        this.getCellStatic()
      } else {
        this.getList()
        this.getStatistics()
      }
    },
    // 获取管控柜列表
    getList() {
      devicecabinetFind(this.formInline).then(res => {
        if (res.state === 0) {
          this.totalData = res.data.total
          this.tableData = res.data.list
        }
      })
    },
    // 获取管控柜统计
    getStatistics() {
      cabinetStatistics(this.formInline).then(res => {
        if (res.state === 0) {
          this.staticsInfo = res.data
        }
      })
    },
    // 选中机构，过滤用户
    selectOu(data) {
      this.formInline.ouId = data.id
      this.$refs.ouSelect.blur()
    },
    // 获取查询组织机构
    getTree() {
      devicecabinetTree({ isContainCabinet: 0 }).then(res => {
        if (res.state === 0) {
          this.ouList = res.data
        }
      })
    },
    // 机构查询 滚动条置顶
    visibleChange(val) {
      this.$nextTick(() => {
        let ele = document.querySelector('.el-select-dropdown__wrap')
        ele.scrollTop = ele.scrollHeight
      })
    },
    // 选中过滤条件机构，过滤用户
    selectParamOu(data) {
      this.$set(this.formInline, 'ouName', data.name)
      this.formInline.ouId = data.ouId
      this.$refs.paramOuSelect.blur()
    },
    // 清空过滤条件机构，过滤用户
    changeParamOu(data) {
      if (!data) {
        this.formInline.ouId = null
        this.formInline.ouName = null
        this.$nextTick(() => {
          this.$refs.paramOuTree.setCurrentKey(null)
        })
      }
    },
    // 当前机构/用户
    handleNodeClick(data, node) {
      if (this.currentTreeKey && this.currentTreeKey.name === data.name) {
        node.checked = !node.checked
      } else {
        node.checked = true
      }
      if (node.checked) {
        // 选中
        this.currentTreeKey = data
        this.defaultId = this.currentTreeKey.ouId
        this.$refs.dataConfigTree.setCurrentKey(data.ouId)
        if (data.type === 1) {
          this.formInline.id = data.cabinetId
          this.formInline.ouId = ''
          this.formInline.pageNum = 1
          this.formInline.pageSize = 30
          this.selectPageSize = [30, 60, 90, 120]
          this.getCells()
          this.getCellStatic()
          this.currentType = 1
        } else {
          this.formInline.id = ''
          this.formInline.pageNum = 1
          this.formInline.pageSize = 12

          this.selectPageSize = [12, 24, 48, 96]
          this.formInline.ouId = data.ouId
          this.formInline.ouName = data.name
          this.getList()
          this.getStatistics()
          this.currentType = 0
        }
      } else {
        // 取消选中
        if (this.$refs.dataConfigTree) {
          this.$refs.dataConfigTree.setCurrentKey(null)
        }
        this.currentTreeKey = null
        this.formInline.id = ''
        this.formInline.pageNum = 1
        this.formInline.pageSize = 12
        this.selectPageSize = [12, 24, 48, 96]
        this.formInline.ouId = ''
        this.formInline.ouName = ''
        this.getList()
        this.getStatistics()
        this.currentType = 0
      }

      // this.currentTreeKey = data
      // type 0 机构 1 管控柜
    },
    // 获取管控柜机构树
    getOusTree() {
      devicecabinetTree({ isContainCabinet: 1 }).then(res => {
        if (res.state === 0) {
          this.mechanismData = res.data
          if (this.mechanismData.length > 0) {
            this.currentTreeKey = this.mechanismData[0]
            this.defaultId = this.currentTreeKey.id
            this.$nextTick(() => {
              // 回显默认选择的item 高亮
              this.$refs.dataConfigTree.setCurrentKey(this.defaultId)
            })
          }
        }
      })
    },
  },
  mounted() {
  },
  created() {
    this.getOusTree()
    this.getList()
    this.getTree()
    this.getStatistics()
  },
}
</script>
<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~@/style/new-set-common.styl'
  @import '~@/style/mixin.styl'
  @import '~@/style/treeLine.styl'
.base_main
  .common-aside-main
    margin-left 10px
    .content
      width: 100%
      height: 638px
      border: var(--search-input-border);
      .static
        color: #333333
        line-height: 40px
        background: #f0f9ff;
        padding: 0px 14px;
        border-bottom: var(--search-input-border);
        span
          font-size: 16px
        .title
          margin-right: 20px
          color: #333333
          .number
            color: #0E65DD
        .text-title
          color: #333333
        .num-icon
          vertical-align: middle
          margin: 0 5px
        .cabinet-num
          margin-left: 16px
          color: #0E65DD
      .cabinets
        margin-top: 16px
        overflow hidden
        padding-left: 16px;
        height: 580px
        overflow: auto
        .cabinet-item
          width: 335px;
          height: 138px;
          float: left
          margin-right: 16px;
          margin-bottom: 16px;
          padding 10px 12px
          border: 1px solid #D1DAE7;
          background: linear-gradient(90deg, #F0F5FF 0%, #FAFCFF 100%);
          border-radius: 4px;
          cursor pointer
          &:nth-child(4n)
            margin-right: 0
          .cabinet-info
            .cabinet-icon
              width: 110px;
              height: 135px;
              margin-right: 16px;
        .item-title
          width 205px
          white-space nowrap
          overflow: hidden
          text-overflow: ellipsis
          font-size: 20px;
          font-weight: 500;
          color: #222222;
          line-height: 50px;
        .item-num
          line-height: 34px;
          color #0E65DD
          display: flex;
          align-items: center;
          span
            font-size: 20px
            font-weight: 500;
          .num-icon
            width 22px
            height 22px
            vertical-align: middle
            margin-right: 5px
        .cell-item
          position: relative
          width: 218px;
          height: 78px;
          float: left
          margin-right: 16px;
          margin-bottom: 16px;
          padding 10px 10px
          border: 1px solid #D1DAE7;
          background: linear-gradient(90deg, #F0F5FF 0%, #FAFCFF 100%);
          border-radius: 4px;
          cursor pointer
          .state
            position: absolute
            top: 0
            right: 0
            width: 30px
            height: 26px
            line-height: 26px
            text-align: center
            background: rgba(255, 0, 0, 0.1)
            color: #FF0000
          .cabinet-info
            .item-num
              color #0E65DD
              span
                font-size: 18px
                font-weight: 500;
            .cell-icon
              position: relative
              i
                position absolute
                left 15px
                top 15px
                font-size: 22px;
                font-weight: 500;
                color: #222222;
            .cabinet-icon
              width: 70px;
              height: 82px;
            .item-title
              width 152px
              height: 35px;
              line-height: 35px;
              white-space nowrap
              overflow: hidden
              text-overflow: ellipsis
      .finsh
        color #00B716
      .idle
        color #8fb5f9
      .symbol
        color #333
  .pagination
    float right
    margin-top 1%
.serachBox
  margin 10px 0
  text-align center
  border-bottom none
  .el-input
    width 290px !important
.el-tree
  height: 92%;
  overflow: auto;
.custom-tree-node
  flex 1
  padding-right 20px
  width 100%
  overflow: hidden
  text-overflow: ellipsis
  white-space: nowrap
  .node-txt
    font-size 16px;/*no*/
    color: #222;
    font-weight: 600;

.serachLine
  display: flex
  align-items: center
  padding: 10px 0!important
  background: #e3e7ed
  .tip
    width: 5px
    height: 30px
    margin-left: 16px
    margin-right: 10px
    background: #0e65dd
    border-radius: 4px
  >>>.el-input
    width: 82%!important
    vertical-align: middle
    .el-input__inner
      border-radius: 6px
      border: 1px solid var(--boredr-color)
      background-color: #fff
      color: #333
      font-size: 14px
      padding: 0 10px
      height: 36px;/*no*/
      line-height: 36px;/*no*/
      &::placeholder
        color: #999
::-webkit-scrollbar
  width 3px
  height 3px
.cellDialog
  .el-input
    width: 140px!important
.theme-dark
  .common-aside
    background-color: #042a85;
    >>>.el-tree-node__content
      color: var(--new-el-select-dropdown-item);
    .serachLine
      background: #002799
    .el-tree
      background: transparent
    .node-txt
      color: #fff;
  .base_main
    .common-aside-main
      .content
        .static
          background: #072368;
          .title
            color: #fff
            .number
              color #00E4FF
          .text-title
            color: #fff
          .cabinet-num
            color #00E4FF
        .cabinets
          .item-num
            color #00E4FF
          .cabinet-item
            border: 1px solid #0974DC;
            background: linear-gradient(90deg, #003986 0%, #001655 100%);
            border-radius: 4px;
          .item-title
            color: #fff
          .cell-item
            border: 1px solid #0974DC;
            background: linear-gradient(90deg, #003986 0%, #001655 100%);
            border-radius: 4px;
            .item-num
              color #00E4FF
      .symbol
        color #fff
</style>
